import styles from '../../styles/Author.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useAppContext } from "../../context/shared";
import qs from "qs";
import Link from 'next/link';
import { Col, Container, Row } from 'react-bootstrap';

const Author = (props: { avatar?: string, name: string, bio: string, id: number }) => {
  const { localization } = useAppContext()
  if (!props.name || !props.bio) return <></>
  return (
    <Container className='bg-gray-5 p-3 rounded-3'>
      <Row className='align-items-center mb-3'>
        <Col md='8' className='align-items-center'>
          {props.avatar && (
            <img className={`me-2 ${styles.avatar}`} src={props.avatar} alt='' />
          )}
          <span className={styles.name}>{localization.blog_written_by} {props.name}</span>
        </Col>
        <Link href={"/blog?" + qs.stringify({ authors: [props.id] })}>
          <Col md='4' className='align-items-center clickable text-start text-md-end mb-3 pe-4 mb-md-0'>
            <span className='caption fw-semibold text-decoration-underline me-2'>{localization.blog_all_by_author_btn}</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </Col>
        </Link>
      </Row>
      <Row>
        <Col>
          <div className='caption text-muted'>{props.bio}</div>
        </Col>
      </Row>
    </Container>
  )
}

export default Author